import { IconArrowRight } from '@shared/ui/icons';
import { formatMillions } from '../financierFormat';
import {
  Section,
  SectionHeader,
  SectionTitle,
  SectionLink,
  GateGrid,
  GateCard,
  GateHeaderBox,
  GateBadge,
  GateTitle,
  GateSubContract,
  GateSubBudget,
  GateSubAccount,
  GateDesc,
  GateStatGrid,
  MetricBox,
  MetricLabel,
  MetricValue,
  MetricNote,
} from './styled';

interface GatesOverviewSectionProps {
  paymentFactory: {
    total_requests_count: number;
    total_in_review_amount: number;
    total_on_ceo_approval_amount: number;
    total_approved_amount: number;
    total_passed_gates_amount: number;
    total_over_budget_amount: number;
    approved_ready_for_1c_count: number;
  };
}

export function GatesOverviewSection({ paymentFactory: pf }: GatesOverviewSectionProps) {
  return (
    <Section>
      <SectionHeader>
        <SectionTitle>Фабрика платежей: 4-ступенчатый финансовый контроль</SectionTitle>
        <SectionLink to="/agents/finance/requests">
          Открыть Фабрику платежей
          <IconArrowRight size={14} />
        </SectionLink>
      </SectionHeader>
      <GateGrid>
        <GateCard>
          <GateHeaderBox>
            <GateBadge $color="#10b981">Д</GateBadge>
            <div>
              <GateTitle>Гейт 1: Договор</GateTitle>
              <GateSubContract>Юридическая чистота</GateSubContract>
            </div>
          </GateHeaderBox>
          <GateDesc>
            Сверка с реестром договоров Юр.модуля (ОСНОВА.Юрист). Проверка статуса, допсоглашений,
            наличия арбитражных споров и банковских реквизитов контрагента.
          </GateDesc>
        </GateCard>

        <GateCard>
          <GateHeaderBox>
            <GateBadge $color="#10b981">П</GateBadge>
            <div>
              <GateTitle>Гейт 2: Первичка</GateTitle>
              <GateSubContract>Закрывающие документы</GateSubContract>
            </div>
          </GateHeaderBox>
          <GateDesc>
            Подтверждение первичных документов: счетов на оплату, УПД, товарных накладных МТО,
            подписанных форм КС-2/КС-3 и табелей УРВ Хронума.
          </GateDesc>
        </GateCard>

        <GateCard>
          <GateHeaderBox>
            <GateBadge $color="#f59e0b">Б</GateBadge>
            <div>
              <GateTitle>Гейт 3: БДДС</GateTitle>
              <GateSubBudget>Лимиты бюджета проекта</GateSubBudget>
            </div>
          </GateHeaderBox>
          <GateDesc>
            Сверка с помесячным бюджетом движения денежных средств. Автоматическая детекция
            превышения лимита статьи затрат с допуском 5%.
          </GateDesc>
        </GateCard>

        <GateCard>
          <GateHeaderBox>
            <GateBadge $color="#0ea5e9">С</GateBadge>
            <div>
              <GateTitle>Гейт 4: Счёт ОБС</GateTitle>
              <GateSubAccount>Маршрутизация списания</GateSubAccount>
            </div>
          </GateHeaderBox>
          <GateDesc>
            Целевое направление платежа: обычный расчётный счёт холдинга, спецсчёт ОБС (сопровождение контрактов)
            или налоговый резерв ЕНС с проверкой достаточности средств.
          </GateDesc>
        </GateCard>
      </GateGrid>

      <GateStatGrid>
        <MetricBox>
          <MetricLabel>Заявок в обработке</MetricLabel>
          <MetricValue>{pf.total_requests_count} шт.</MetricValue>
          <MetricNote>
            На сумму {formatMillions(pf.total_in_review_amount + pf.total_on_ceo_approval_amount + pf.total_approved_amount)}
          </MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Прошли все 4 гейта</MetricLabel>
          <MetricValue $color="#10b981">{formatMillions(pf.total_passed_gates_amount)}</MetricValue>
          <MetricNote>Готовы к акцепту Генерального директора</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Превышение лимитов БДДС</MetricLabel>
          <MetricValue $color="#ef4444">{formatMillions(pf.total_over_budget_amount)}</MetricValue>
          <MetricNote>Требуют спецсогласования Финдиректора / Гендиректора</MetricNote>
        </MetricBox>
        <MetricBox>
          <MetricLabel>Одобрено Гендиректором к 1С</MetricLabel>
          <MetricValue $color="#3b82f6">{pf.approved_ready_for_1c_count} заявок</MetricValue>
          <MetricNote>{formatMillions(pf.total_approved_amount)} готово к экспорту</MetricNote>
        </MetricBox>
      </GateStatGrid>
    </Section>
  );
}
